import { Injectable } from '@angular/core';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';

import { ProfileService } from '../profile/profile.service';


@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private analytics: FirebaseAnalytics,private profile: ProfileService) {
     profile.getProfile().subscribe((p)=>{
       this.analytics.setUserId(p.email);
       this.analytics.setUserProperty("uclass",p.class);
       this.analytics.setUserProperty("ueducation",p.edulevel);
       this.analytics.setUserProperty("uinstitution",p.institution);
       this.analytics.setUserProperty("uspecialty",p.specialty);
     });
  }

  public logEvent(event,screenname,data:any={}) {
      //use log event to log the basics
      this.analytics.setCurrentScreen(screenname);
      this.analytics.logEvent(event, { page: screenname, ...data });
      console.log("Analytics: " + event + ":" + screenname,{ page: screenname, ...data });
  }

}
